import { render, staticRenderFns } from "./Triangle1.vue?vue&type=template&id=088d7848&"
import script from "./Triangle1.vue?vue&type=script&lang=js&"
export * from "./Triangle1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports